// extracted by mini-css-extract-plugin
module.exports = {"projectName":"_75d0f711"};